// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sportsbook-traditional-header-date {
  color: #FFF !important;
  font-family: Inter !important;
  font-style: normal !important;
  font-weight: 700 !important;
  line-height: 150% !important;
  letter-spacing: -0.87px !important;
  font-size: clamp(10px, 2vw, 16px) !important;
}
@media (min-width: 768px) {
  .sportsbook-traditional-header-date {
    font-size: 16px !important;
  }
}

.sportsbook-traditional-header-bet-types {
  color: #FFF !important;
  font-family: Inter !important;
  font-style: normal !important;
  font-weight: 700 !important;
  line-height: 150% !important;
  letter-spacing: -0.87px !important;
  font-size: clamp(10px, 2vw, 16px) !important; /* Responsive font size */
  flex: 1 1 !important;
  text-align: center !important;
}
@media (min-width: 768px) {
  .sportsbook-traditional-header-bet-types {
    font-size: 16px !important; /* Lock font size at 16px when screen width is 768px or more */
  }
}

.sportsbook-traditional-team-logo {
  width: clamp(16px, 4vw, 24px) !important;
  height: clamp(16px, 4vw, 24px) !important;
  object-fit: contain !important;
}

.sportsbook-traditional-team-name {
  color: #002129 !important;
  font-family: Inter !important;
  font-style: normal !important;
  font-weight: 600 !important;
  white-space: nowrap !important;
  font-size: clamp(10px, 3vw, 16px) !important;
}
@media (min-width: 768px) {
  .sportsbook-traditional-team-name {
    font-size: 16px !important;
  }
}

.sportsbook-traditional-at-symbol {
  color: #002129 !important;
  font-family: Inter !important;
  font-style: normal !important;
  font-weight: 800 !important;
  font-size: clamp(12px, 2vw, 14px) !important;
  margin-left: 4px !important;
  margin-right: 4px !important;
}

.sportsbook-traditional-bet-button {
  height: 40px !important;
  width: 100% !important;
  font-size: clamp(12px, 2vw, 14px) !important;
  white-space: pre-line !important;
  line-height: 1.2 !important;
  border: 1px solid #002129 !important;
  background-color: white !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
}
.sportsbook-traditional-bet-button span {
  display: inline-flex !important;
  flex-direction: column !important;
  align-items: center !important;
  gap: 3px !important;
}
@media (min-width: 600px) {
  .sportsbook-traditional-bet-button {
    white-space: nowrap !important;
    line-height: normal !important;
    flex-direction: row !important;
  }
}
.sportsbook-traditional-bet-button.active {
  background-color: #002129 !important;
  color: white !important;
  border: 1px solid #002129 !important;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.2) !important;
}

.sportsbook-traditional-bet-button-text1 {
  color: #002129 !important;
  white-space: nowrap !important;
}
.sportsbook-traditional-bet-button-text1.active {
  color: white !important;
  background-color: #002129 !important;
}

.sportsbook-traditional-bet-button-text2 {
  color: #00AAD1 !important;
  white-space: nowrap !important;
}

.sportsbook-traditional-button-pair {
  display: flex !important;
  flex-direction: column !important;
  align-items: center !important;
  gap: 2px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/SportsbookComponents/TraditionalBetCard/TraditionalBetCard.scss"],"names":[],"mappings":"AAAA;EACI,sBAAA;EACA,6BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,kCAAA;EACA,4CAAA;AACJ;AACI;EATJ;IAUQ,0BAAA;EAEN;AACF;;AACA;EACI,sBAAA;EACA,6BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4BAAA;EACA,kCAAA;EACA,4CAAA,EAAA,yBAAA;EACA,oBAAA;EACA,6BAAA;AAEJ;AAAI;EAXJ;IAYQ,0BAAA,EAAA,8DAAA;EAGN;AACF;;AACA;EACI,wCAAA;EACA,yCAAA;EACA,8BAAA;AAEJ;;AAEA;EACI,yBAAA;EACA,6BAAA;EACA,6BAAA;EACA,2BAAA;EACA,8BAAA;EACA,4CAAA;AACJ;AACI;EARJ;IASQ,0BAAA;EAEN;AACF;;AACA;EACI,yBAAA;EACA,6BAAA;EACA,6BAAA;EACA,2BAAA;EACA,4CAAA;EACA,2BAAA;EACA,4BAAA;AAEJ;;AACA;EACI,uBAAA;EACA,sBAAA;EAEA,4CAAA;EACA,gCAAA;EACA,2BAAA;EACA,oCAAA;EACA,kCAAA;EACA,wBAAA;EACA,8BAAA;EACA,kCAAA;AACJ;AACI;EACI,+BAAA;EACA,iCAAA;EACA,8BAAA;EACA,mBAAA;AACR;AAEI;EApBJ;IAqBQ,8BAAA;IACA,8BAAA;IACA,8BAAA;EACN;AACF;AAEI;EACI,oCAAA;EACA,uBAAA;EACA,oCAAA;EACA,iDAAA;AAAR;;AAIA;EACI,yBAAA;EACA,8BAAA;AADJ;AAGI;EACI,uBAAA;EACA,oCAAA;AADR;;AAKA;EACI,yBAAA;EACA,8BAAA;AAFJ;;AAKA;EACI,wBAAA;EACA,iCAAA;EACA,8BAAA;EACA,mBAAA;AAFJ","sourcesContent":[".sportsbook-traditional-header-date {\n    color: #FFF !important;\n    font-family: Inter !important;\n    font-style: normal !important;\n    font-weight: 700 !important;\n    line-height: 150% !important;\n    letter-spacing: -0.87px !important;\n    font-size: clamp(10px, 2vw, 16px) !important;\n\n    @media (min-width: 768px) {\n        font-size: 16px !important;\n    }\n}\n\n.sportsbook-traditional-header-bet-types {\n    color: #FFF !important;\n    font-family: Inter !important;\n    font-style: normal !important;\n    font-weight: 700 !important;\n    line-height: 150% !important;\n    letter-spacing: -0.87px !important;\n    font-size: clamp(10px, 2vw, 16px) !important; /* Responsive font size */\n    flex: 1 !important;\n    text-align: center !important;\n\n    @media (min-width: 768px) {\n        font-size: 16px !important; /* Lock font size at 16px when screen width is 768px or more */\n    }\n}\n\n\n.sportsbook-traditional-team-logo {\n    width: clamp(16px, 4vw, 24px) !important; // Responsive width that scales from 16px to 24px based on viewport width\n    height: clamp(16px, 4vw, 24px) !important; // Responsive height that scales from 16px to 24px based on viewport width\n    object-fit: contain !important;\n}\n\n\n.sportsbook-traditional-team-name {\n    color: #002129!important;\n    font-family: Inter !important;\n    font-style: normal !important;\n    font-weight: 600 !important;\n    white-space: nowrap !important; // Prevent text from wrapping\n    font-size: clamp(10px, 3vw, 16px) !important; // Responsive font size that scales from 10px to 16px based on viewport width\n\n    @media (min-width: 768px) {\n        font-size: 16px !important; // Lock font size at 16px when screen width is 768px or more\n    }\n}\n\n.sportsbook-traditional-at-symbol {\n    color: #002129 !important;\n    font-family: Inter !important;\n    font-style: normal !important;\n    font-weight: 800 !important;\n    font-size: clamp(12px, 2vw, 14px) !important; // Responsive font size\n    margin-left: 4px !important;  // Space between the line and the @ symbol\n    margin-right: 4px !important;  // Space between @ symbol and the line\n}\n\n.sportsbook-traditional-bet-button {\n    height: 40px !important;\n    width: 100% !important; // Full width of its container\n    //margin-bottom: 2px !important;\n    font-size: clamp(12px, 2vw, 14px) !important; // Responsive font size\n    white-space: pre-line !important; // Multi-line on small screens\n    line-height: 1.2 !important; // Adjust line height for multi-line text\n    border: 1px solid #002129 !important; // Border color and width\n    background-color: white !important; // Background color\n    display: flex !important; // Ensure flex properties are applied\n    align-items: center !important; // Align items center vertically\n    justify-content: center !important; // Center items horizontally\n\n    & span {\n        display: inline-flex !important;\n        flex-direction: column !important; // Stack text on small screens\n        align-items: center !important; // Align juice next to the line\n        gap: 3px !important; // Space between line and juice on larger screens\n    }\n\n    @media (min-width: 600px) {\n        white-space: nowrap !important; // Single line on larger screens\n        line-height: normal !important; // Adjust line height for single-line text\n        flex-direction: row !important; // Inline text on larger screens\n    }\n\n    // Add styles for the active state\n    &.active {\n        background-color: #002129 !important; // Example active background color\n        color: white !important; // Example active text color\n        border: 1px solid #002129 !important; // Example border color for active state\n        box-shadow: 0 0 5px rgba(0, 0, 0, 0.2) !important; // Optional: shadow effect for active state\n    }\n}\n\n.sportsbook-traditional-bet-button-text1 {\n    color: #002129 !important; // Text color\n    white-space: nowrap !important; // Prevent text from wrapping\n\n    &.active {\n        color: white !important; // Example active text color\n        background-color: #002129 !important; // Example active background color\n    }\n}\n\n.sportsbook-traditional-bet-button-text2 {\n    color: #00AAD1 !important; // Text color\n    white-space: nowrap !important; // Prevent text from wrapping\n}\n\n.sportsbook-traditional-button-pair {\n    display: flex !important;\n    flex-direction: column !important; // Stack buttons vertically\n    align-items: center !important; // Center buttons horizontally\n    gap: 2px !important; // Space between buttons\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
